
import { IconButtonPropsEventType, IconButtonProperty } from '@/ui-kit/components/icon-button/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import IconButton from '@/ui-kit/components/icon-button';
import StylesMixin from '@/ui-kit/mixins/styles';
import { SoldDataTableEventType } from './enums';

export default {
  name: 'SoldDataTableTransactionsCell',
  components: { IconButton },
  mixins: [StylesMixin],
  props: {
    transactions: {
      required: true,
      type: Array,
    },
    addressId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      IconType,
      IconButtonPropsEventType,
      IconButtonProperty,
      currentTransactionIndex: 0,
    };
  },
  computed: {
    isLeftButtonDisabled() {
      return this.currentTransactionIndex === 0;
    },
    isRightButtonDisabled() {
      return this.currentTransactionIndex === this.transactions.length - 1;
    },
  },
  methods: {
    handleLeftArrowButtonClick() {
      this.currentTransactionIndex -= 1;
      this.emitTransactionChange();
    },
    handleRightArrowButtonClick() {
      this.currentTransactionIndex += 1;
      this.emitTransactionChange();
    },
    emitTransactionChange() {
      this.$emit(SoldDataTableEventType.TransactionChange, {
        addressId: this.addressId,
        index: this.currentTransactionIndex,
      });
    },
  },
};
